import {
  sectionHeaderBackgroundV2,
  sectionHeaderBlankBackgroundV2,
} from '@features/lci-report/images';
import {
  ImageProps,
  ImageWithMetadata,
  inmarketLogoV2,
  resizeToHeight,
  slideBackgroundLight,
  SlideMasterProps,
} from '@features/powerpoint';
import { SLIDE_WIDTH } from './shared-presentation-config-v2';

const BRAND_LOGO_HEIGHT = 0.82;
const BRAND_LOGO_Y_POSITION = 0.25;

export const slideMasters = {
  title: 'TITLE_SLIDE',
  cover: 'COVER_SLIDE',
  dark: 'DARK_SLIDE',
  light: 'LIGHT_SLIDE',
} as const;

const brandLogoImageProps = (
  brandLogoWithMetadata: ImageWithMetadata | null
): ImageProps => {
  if (!brandLogoWithMetadata) return {};

  const resizedBrandLogo = resizeToHeight(
    brandLogoWithMetadata,
    BRAND_LOGO_HEIGHT
  );

  const yPosition =
    resizedBrandLogo.height < BRAND_LOGO_HEIGHT
      ? BRAND_LOGO_Y_POSITION +
        (BRAND_LOGO_HEIGHT - resizedBrandLogo.height) / 2
      : BRAND_LOGO_Y_POSITION;

  return {
    data: resizedBrandLogo.data,
    x: SLIDE_WIDTH - resizedBrandLogo.width - 0.22,
    y: yPosition,
    w: resizedBrandLogo.width,
    h: resizedBrandLogo.height,
  };
};

export const buildSlideMasters = (
  brandLogo: ImageWithMetadata | null
): SlideMasterProps[] => {
  return [
    {
      title: slideMasters.title,
      background: { path: slideBackgroundLight },
    },
    {
      title: slideMasters.cover,
      background: { path: sectionHeaderBackgroundV2 },
    },
    {
      title: slideMasters.dark,
      background: { path: sectionHeaderBlankBackgroundV2 },
      objects: [
        {
          image: brandLogoImageProps(brandLogo),
        },
      ],
    },
    {
      title: slideMasters.light,
      background: { path: slideBackgroundLight },
      objects: [
        {
          image: brandLogoImageProps(brandLogo),
        },
        {
          image: {
            path: inmarketLogoV2,
            h: 0.2,
            w: 1.16,
            x: 0.42,
            y: 7.17,
          },
        },
      ],
    },
  ];
};
